import React, { useEffect, useRef, MutableRefObject } from 'react';
import { useSelector } from 'react-redux';
import { EditorToolbarCustomFormatActionProps } from '@dev/template-editor';
import { getAiTextStore } from '@/store/aiText/actions';
import useMobile from '@/services/hooks/useMobile';
import { EditorType } from '@/services/dictionaries/EditorType';
import { AiTextChatList } from '../AiTextChatList';
import { AiTextTips } from '../AiTextTips';
import { AiTextModalBodyWrapper } from './styles';
import { useAreNewPromptsDisabled } from '../../hooks/useAreNewPromptsDisabled';

export interface AiTextModalBodyProps extends EditorToolbarCustomFormatActionProps {
    editorType?: EditorType;
    inputWrapperRef: MutableRefObject<HTMLDivElement>;
}

export const AiTextModalBody = (props: AiTextModalBodyProps): JSX.Element => {
    const { areNewPromptsDisabled } = useAreNewPromptsDisabled();
    const { isBusy, list } = useSelector(getAiTextStore);
    const listWrapperRef = useRef<HTMLDivElement>();
    const isMobile = useMobile();
    useEffect((): void => {
        if (listWrapperRef.current && list?.length && isBusy) {
            setTimeout(() => {
                listWrapperRef.current?.querySelector('div > :last-child')?.scrollIntoView(false);
            }, 0);
        }
    }, [list, isBusy]);

    if (list?.length || areNewPromptsDisabled) {
        return (
            <AiTextModalBodyWrapper ref={listWrapperRef} isMobile={isMobile}>
                <AiTextChatList {...props} />
            </AiTextModalBodyWrapper>
        );
    }

    return (
        <AiTextModalBodyWrapper ref={listWrapperRef} isMobile={isMobile}>
            <AiTextTips inputWrapperRef={props.inputWrapperRef} />
        </AiTextModalBodyWrapper>
    );
};
